let faqHeader = document.querySelectorAll('.faq-header');

// console.log(faqHeader);

faqHeader.forEach(item => {
    item.addEventListener('click', function(e) {
        let currentdata = this.dataset.body;
        let currentIcon = this.dataset.icon;
        // console.log('object :>> ', currentdata);
        let faqBody = document.querySelector(`#${currentdata}`)
        let faqIcon = document.querySelector(`#${currentIcon}`)
        // console.log('object :>> ', faqBody);
        let isActive = faqBody.classList.contains('faq-acitve');
        if (!isActive) {
            faqBody.classList.add('faq-acitve');
            faqBody.style.maxHeight = faqBody.scrollHeight + "px"; 
            faqIcon.classList.add('fq-toggle-btn-rotate')
        }
        else {
            faqBody.classList.remove('faq-acitve');
            faqBody.style.maxHeight = 0;
            faqIcon.classList.remove('fq-toggle-btn-rotate')
        }
        
    })
})